module.exports = __webpack_public_path__ + "img/CellCycle-CECA_10X_CC.52f6e4e7.png";